// extracted by mini-css-extract-plugin
export var originalPrice = "_va-0";